export default class ModalPasswordChangeConfirmationController {
	/* @ngInject */
	constructor($uibModalInstance) {
		this.$uibModalInstance = $uibModalInstance;
	}

	login() {
		this.$uibModalInstance.close();
	}
}
